function formatCardNumber(value) {
  const numericValue = value.replace(/\D/g, "");

  return numericValue.replace(/(\d{4})(?=\d)/g, "$1 ");
}

export default formatCardNumber;
